import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowPreviousSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.414 6.414 7.828 12l5.586 5.586L12 19l-7-7 7-7 1.414 1.414Zm5.586 0L13.414 12 19 17.586 17.586 19l-7-7 7-7L19 6.414Z"
    />
  </svg>
);
export default IconArrowPreviousSizeM;
